import { supplierTypeList, reportAuditStatusList, creditRoundList } from '../../components/componentsData';

export const fieldList = [
  {
    label: '申请单号',
    type: 'input',
    value: 'applyCode'
  },
  {
    label: 'EQE编码',
    type: 'input',
    value: 'evaluationCode'
  },
  {
    label: '审核状态',
    type: 'select',
    value: 'auditStatus',
    list: 'reportAuditStatusList'
  },
  {
    label: '申请企业',
    type: 'input',
    value: 'companyName'
  },
  {
    label: '供应商类型',
    type: 'select',
    value: 'supplierType',
    list: 'supplierTypeList'
  },
  {
    label: '评价类型',
    type: 'select',
    value: 'creditRound',
    list: 'creditRoundList'
  }
];

export const listTypeInfo = {
  supplierTypeList,
  reportAuditStatusList,
  creditRoundList
};

export const tableLabel = [
  {
    label: '序号',
    align: 'center',
    slot: 'index',
    width: 50
  },
  {
    label: '申请单号',
    param: 'applyCode',
    align: 'center',
    minWidth: 110
  },
  {
    label: '申请企业',
    param: 'companyName',
    align: 'center',
    tooltip: true,
    minWidth: 140
  },
  {
    label: '供应商类型',
    param: 'supplierType',
    align: 'center',
    minWidth: 110,
    render({ supplierType }) {
      return supplierTypeList.find(item => item.id?.toString() === supplierType)?.name || '';
    }
  },
  {
    label: 'EQE编码',
    param: 'evaluationCode',
    align: 'center',
    tooltip: true,
    minWidth: 140
  },
  {
    label: '产品名称',
    param: 'productName',
    align: 'center',
    tooltip: true,
    minWidth: 140
  },
  {
    label: '评价类型',
    param: 'creditRound',
    align: 'center',
    minWidth: 110,
    render({ creditRound }) {
      if (creditRound === '1') {
        return '初评';
      } else {
        return '复评';
      }
    }
  },
  {
    label: '审核状态',
    param: 'auditStatus',
    align: 'center',
    minWidth: 110,
    render({ auditStatus }) {
      return reportAuditStatusList.find(item => item.id === auditStatus)?.name || '';
    }
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '100',
    slot: 'handle'
  }
];
